import axios from 'axios'
import { Message } from 'element-ui'
import { RESULT_CODE } from './api-config'
import { redirectToLogin } from '@/utils/auth'; // 导入工具函数
import { getSessionStorage } from '@/utils/util'; // 导入getSessionStorage方法

// 获取当前协议
const getProtocol = () => {
  return window.location.protocol
}

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 300000,
  headers: {'Content-Type': 'application/json'}
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    const token = getSessionStorage('token')
    if (token) {
      config.headers['access-token'] = token
    }
    return config
  },
  error => Promise.reject(error)
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    // 根据后端API的返回格式调整
    if (
      response.data.errorCode === 100001 ||
      response.data.resultCode === 100001 ||
      response.data.resultCode === 100002 ||
      response.data.resultCode === 1030102 ||
      response.data.resultCode === 200201
    ) {
      // Message({
      //   message: res.resultMsg || '登录超时,正在重新登录...',
      //   type: 'error',
      //   duration: 5 * 1000
      // })
      // resultMsg = '登录超时,正在重新登录...';
      // success = false;
      // store.dispatch('logout');
      Message({
        message: '登录超时,正在重新登录...',
        type: 'error',
        duration: 5 * 1000
      })
      redirectToLogin();
      return Promise.reject(new Error(res.resultMsg || '未知错误'))
    }else if (res.resultCode !== RESULT_CODE.SUCCESS) {
      Message({
        message: res.resultMsg || '请求失败',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(new Error(res.resultMsg || '未知错误'))
    }
    res.success = true;
    return res
  },
  error => {
    let message = '网络请求失败'
    if (error.response) {
      switch (error.response.status) {
        case 401:
          message = '登录已过期，请重新登录'
          // 可以在这里处理登出和跳转到登录页
          break
        case 403:
          message = '没有权限执行此操作'
          break
        case 404:
          message = '请求的资源不存在'
          break
        case 500:
          message = '服务器内部错误'
          break
        default:
          message = `请求失败(${error.response.status})`
      }
    }
    Message({
      message: message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service 